<template>
  <div class="form-grid" :style="colsStyle">
    <slot />
  </div>
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'FormGrid',
  props: {
    cols: { type: [Number, String], default: 2 },
  },
  setup(props) {
    const colsStyle = computed(() => ({
      '--form-grid-cols': Number(props.cols) || 2,
    }))
    return { colsStyle }
  },
}
</script>

<style scoped>
.form-grid {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(var(--form-grid-cols, 2), minmax(0, 1fr));
}

@media (max-width: 720px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
}
</style>
